import { motion } from "framer-motion";
import mentorshipImage from "../../Assets/images/ugaal.png";
import "./MentorshipPage.css";

export default function MentorshipPage() {
  // const stats = [
  //   { label: "Total Mentors", value: 42 },
  //   { label: "Total Mentees", value: 128 },
  // ];

  // const matches = [
  //   {
  //     sn: 1,
  //     mentee: "Ama Boateng",
  //     mentor: "Dr. Kwame Mensah (Software Engineering)",
  //   },
  //   {
  //     sn: 2,
  //     mentee: "Yaw Asare",
  //     mentor: "Mrs. Akosua Owusu (Finance)",
  //   },
  //   {
  //     sn: 3,
  //     mentee: "Esi Darko",
  //     mentor: "Mr. Daniel Agyeman (Civil Engineering)",
  //   },
  // ];

  return (
    <div className="mentor-page">
      {/* ================= Hero Section ================= */}
      <motion.section
        className="mentor-hero"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <img
          src={mentorshipImage}
          alt="Alumni mentorship session"
          className="mentor-hero-image"
        />

        <div className="mentor-hero-overlay">
          <h1>Alumni Mentorship Program</h1>
          <p>Connecting experience with ambition</p>
        </div>
      </motion.section>

      {/* ================= Program Section ================= */}
      <motion.section
        className="mentor-program-section"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <div className="mentor-program-container">
          <h2>About the Program</h2>
          <p className="mentor-program-intro">
            The Alumni Mentorship Program connects experienced alumni
            professionals with students and young graduates to provide career
            guidance, industry exposure, and personal development support.
          </p>

          <div className="mentor-program-points">
            <div className="mentor-program-card">
              <h4>Objectives</h4>
              <p>
                Career guidance, skills transfer, professional growth, and
                academic-to-industry transition support.
              </p>
            </div>

            <div className="mentor-program-card">
              <h4>Benefits</h4>
              <p>
                Networking opportunities, real-world insights, leadership
                development, and career confidence.
              </p>
            </div>
          </div>
        </div>
      </motion.section>

      {/* ================= Main Content ================= */}
      <div className="mentor-content">
        <center> Mentorship Registration Coming Soon ...</center>
        {/* Action Buttons */}
        {/* <motion.div
          className="mentor-action-buttons"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <button className="mentor-btn primary">Register as Mentor</button>
          <button className="mentor-btn secondary">Register as Mentee</button>
          <button className="mentor-btn outline">Contact Us</button>
        </motion.div>

        {/* Stats */}
        {/* <section className="mentor-stats-grid">
          {stats.map((item, index) => (
            <motion.div
              key={index}
              className="mentor-stat-card"
              whileHover={{ y: -6 }}
              transition={{ duration: 0.3 }}
            >
              <h3>{item.value}</h3>
              <p>{item.label}</p>
            </motion.div>
          ))}
        </section>

        {/* Matching Table */}
        {/* <motion.section
          className="mentor-matching-table"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <h2>Mentorship Matches</h2>

          <table>
            <thead>
              <tr>
                <th>SN</th>
                <th>Mentee</th>
                <th>Mentor</th>
              </tr>
            </thead>
            <tbody>
              {matches.map((row) => (
                <tr key={row.sn}>
                  <td>{row.sn}</td>
                  <td>{row.mentee}</td>
                  <td>{row.mentor}</td>
                </tr>
              ))}
            </tbody>
          </table> */} {/* </motion.section> 
        */}
      </div>
    </div>
  );
}
